// DS: C85A, C85A_M
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { TabBarProps } from './types';
import SearchBar from './_partials/SearchBar';
import TabBar from './_partials/TabBar';
import TitleBlock from './_partials/TitleBlock';

import s from './Header.scss';

const Header: React.FC<TabBarProps> = ({
  isSearchPage,
  pageType,
  items,
  title,
  tagline,
  rightSideContent,
  leftSideContent,
  activeMenuItem,
  children,
  className,
  titleClassName,
  withNavigation = true,
  isSticky: isStickyProp,
}) => {
  const isMobile = useContext(MobileContext);
  const isSticky = isStickyProp ?? (!isMobile || withNavigation);

  const hasLeftSideContent = !isMobile || leftSideContent;
  const hasRightSideContent = !isMobile || rightSideContent;
  const showNavigationBar =
    !isMobile || withNavigation || hasRightSideContent || hasLeftSideContent;

  return (
    <>
      {isSearchPage && <SearchBar pageType={pageType} />}
      {isMobile && (
        <TitleBlock
          title={title}
          tagline={tagline}
          className={classnames(s['title'], titleClassName)}
          withBackground={withNavigation}
        />
      )}
      {showNavigationBar && (
        <div
          className={classnames(
            s['header-container'],
            isSticky && s['sticky'],
            className
          )}
        >
          <header className={s['header']} data-hook={BiDataHook.DEVIATION_NAV}>
            {hasLeftSideContent &&
              (leftSideContent ? (
                <div className={s['left-side']}>{leftSideContent}</div>
              ) : (
                !isMobile && (
                  <TitleBlock
                    title={title}
                    tagline={tagline}
                    className={classnames(s['left-side'], titleClassName)}
                  />
                )
              ))}
            {withNavigation && (
              <TabBar
                items={items}
                activeMenuItem={activeMenuItem}
                className={s['navigation']}
              >
                {children}
              </TabBar>
            )}
            {hasRightSideContent && (
              <div className={s['right-side']}>{rightSideContent}</div>
            )}
          </header>
        </div>
      )}
    </>
  );
};
Header.displayName = 'Header';

export default Header;
